import {
  LoadingOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ExpertModal from "./modals/expertModal";
import { Button, Input, Select } from "antd";

const Experts = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  let type = localStorage.getItem("usertype");
  const experts = [
    {
      title: "Иванов Алексей Сергеевич",
      trusted:
        "Ярославский государственный университет, факультет экономики, магистр (2010)",
      percent: 12.9,
    },
    {
      title: "Мария Петрова",
      trusted:
        "Ярославский государственный технический университет, факультет информационных технологий, бакалавр (2015)",
      percent: 6.18,
    },
    {
      title: "Сидоров Дмитрий Викторович",
      trusted:
        "Ярославский государственный университет, факультет права, бакалавр (2012)",
      percent: 3.74,
    },
    {
      title: "Иванов Алексей Сергеевич",
      trusted:
        "Ярославский государственный университет, факультет экономики, магистр (2010)",
      percent: 12.9,
    },
    {
      title: "Мария Петрова",
      trusted:
        "Ярославский государственный технический университет, факультет информационных технологий, бакалавр (2015)",
      percent: 6.18,
    },
    {
      title: "Сидоров Дмитрий Викторович",
      trusted:
        "Ярославский государственный университет, факультет права, бакалавр (2012)",
      percent: 3.74,
    },
    {
      title: "Иванов Алексей Сергеевич",
      trusted:
        "Ярославский государственный университет, факультет экономики, магистр (2010)",
      percent: 12.9,
    },
    {
      title: "Мария Петрова",
      trusted:
        "Ярославский государственный технический университет, факультет информационных технологий, бакалавр (2015)",
      percent: 6.18,
    },
    {
      title: "Сидоров Дмитрий Викторович",
      trusted:
        "Ярославский государственный университет, факультет права, бакалавр (2012)",
      percent: 3.74,
    },
    {
      title: "Иванов Алексей Сергеевич",
      trusted:
        "Ярославский государственный университет, факультет экономики, магистр (2010)",
      percent: 12.9,
    },
    {
      title: "Мария Петрова",
      trusted:
        "Ярославский государственный технический университет, факультет информационных технологий, бакалавр (2015)",
      percent: 6.18,
    },
    {
      title: "Сидоров Дмитрий Викторович",
      trusted:
        "Ярославский государственный университет, факультет права, бакалавр (2012)",
      percent: 3.74,
    },
    {
      title: "Иванов Алексей Сергеевич",
      trusted:
        "Ярославский государственный университет, факультет экономики, магистр (2010)",
      percent: 12.9,
    },
    {
      title: "Мария Петрова",
      trusted:
        "Ярославский государственный технический университет, факультет информационных технологий, бакалавр (2015)",
      percent: 6.18,
    },
    {
      title: "Сидоров Дмитрий Викторович",
      trusted:
        "Ярославский государственный университет, факультет права, бакалавр (2012)",
      percent: 3.74,
    },
  ];

  const [keys, setKeys] = useState(experts);

  useEffect(() => {
    !window.location.href.includes("source") && setKeys(experts.slice(0, 3));
  }, []);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    console.log(event.target.value);
    !window.location.href.includes("source")
      ? setKeys(
          experts
            .filter((key) =>
              key.title.toUpperCase().includes(event.target.value.toUpperCase())
            )
            .slice(0, 3)
        )
      : setKeys(
          experts.filter((key) =>
            key.title.toUpperCase().includes(event.target.value.toUpperCase())
          )
        );
  };

  const closeModal = (value: any) => {
    setModalOpen(false);
  };

  return (
    <div className="white-block">
      <p className="block-title">Эксперты</p>
      {!window.location.href.includes("source") && (
        <div className="flex-space margin-bottom">
          <p className="block-title">Эксперты предприятия</p>
          {type == "industry" && (
            <div>
              <Button
                onClick={() => {
                  setModalOpen(true);
                  setUser({});
                }}
              >
                <PlusOutlined /> Добавить эксперта организации
              </Button>
            </div>
          )}
        </div>
      )}
      <Input
        addonBefore={<SearchOutlined />}
        placeholder="Поиск"
        style={{ width: 200 }}
        onChange={handleSearch}
      />
      {"   "}
      <Select
        style={{ width: 200 }}
        allowClear={false}
        options={[
          { value: "металлургия" },
          { value: "машиностроение" },
          { value: "нефтеперерабатывающая" },
          { value: "химическая" },
          { value: "лесопромышленный комплекс" },
          { value: "целлюлозно-бумажная" },
          { value: "строительных материалов" },
          { value: "электроэнергетика" },
          { value: "агропромышленный комплекс" },
          { value: "пищевая" },
          { value: "легкая" },
        ]}
        placeholder="Отрасль"
        showSearch
      />
      <div className="flex-space margin-bottom"></div>
      {loading ? (
        <div className="feed-posts-loader">
          <LoadingOutlined />
        </div>
      ) : (
        <div className="grid3">
          {keys?.map((item: any, id) => (
            <div className="grid-block gray-block" key={id}>
              <div className="margin-bottom">
                <div className="flex-space">
                  <div className="user-widget">
                    <div className="user-img">
                      <div className={"flex-c"}></div>
                      {item.title?.split(" ")[0]?.slice(0, 1).toUpperCase() ||
                        ""}{" "}
                      {item.title?.split(" ")[1]?.slice(0, 1).toUpperCase() ||
                        ""}
                    </div>
                  </div>
                  {type == "industry" && (
                    <img
                      src="/settings.png"
                      alt="Редактировать"
                      onClick={() => {
                        setModalOpen(true);
                        setUser(item);
                      }}
                    />
                  )}
                </div>
                <div className="block-title">
                  <p className="title-small">{item.title}</p>
                  <p>{item?.trusted}</p>
                </div>
              </div>
              <ExpertModal
                open={modalOpen}
                isCloseModal={closeModal}
                user={user}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Experts;
